
/**
 * 수료증 유형
 */
export type GetEnrollment200CertificatesItemCertificateType = typeof GetEnrollment200CertificatesItemCertificateType[keyof typeof GetEnrollment200CertificatesItemCertificateType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEnrollment200CertificatesItemCertificateType = {
  COMPLETION: 'COMPLETION',
  PARTICIPATION: 'PARTICIPATION',
  ACHIEVEMENT: 'ACHIEVEMENT',
} as const;
